import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, Observable, throwError, map, switchMap, catchError, tap } from 'rxjs';
import * as ActionConfigurationManager from '.././_actions/config.actions';
import { getPDFSuccess, getPDFFailed, downloadPDFSuccess, downloadPDFFailed, postServiceAgreementSuccess, postServiceAgreementFailed, postPaymentPlanAgreementSuccess, postPaymentPlanAgreementFailed, getPaymentPlanAgreementSuccess, getPaymentPlanAgreementFailed, setDateAndTimeFailed, downloadPaymentPlanAgreementSuccess, downloadPaymentPlanAgreementFailed, getContractByUuidSuccess, getContractByUuidFailed, updatePDFExpirationSuccess, updatePDFExpirationFailed, getOhioCancellationFormSuccess, getOhioCancellationFormFailed } from '../_actions/pdf.actions';
import { DataLookupService } from '../_services/data-lookup.service';
import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Action, Store } from '@ngrx/store';
import { get } from 'jquery';
import { ViewContractRequest, ViewContractResponse } from '../_models/pdf';


@Injectable()

export class PDFEffects {

    public downloadPDF$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(ActionConfigurationManager.DOWNLOAD_PDF),
            switchMap((action: any) => this.pdfService.generatePDF(action)
                .pipe(
                    map(pdf => {
                        console.log(pdf);
                        if (pdf) {
                            const linkSource = 'data:application/pdf;base64,' + pdf.data
                            const downloadLink = document.createElement("a");
                            const fileName = "Coverage Agreement.pdf";

                            downloadLink.href = linkSource;
                            downloadLink.download = fileName;
                            downloadLink.click();
                            return downloadPDFSuccess(pdf);
                        } else {
                            return downloadPDFFailed(pdf)
                        }

                    }),
                    catchError((error) => {
                        return throwError(error)
                    })
                )
            )
        )
    )

    public getPDF$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(ActionConfigurationManager.GET_PDF),
            switchMap((action: any) => this.pdfService.generatePDF(action)
                .pipe(
                    map(pdf => {
                        if (pdf) {
                            console.log(pdf);
                            let pdfWindow = window.open("")
                            pdfWindow.document.title = "Vehicle Service Contract"
                            pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(pdf.data) + "' ></iframe>")
                            return getPDFSuccess(pdf);
                        } else {
                            // return failed pdf
                            return getPDFFailed(pdf)
                        }

                    }),
                    catchError((error) => {
                        return throwError(error)
                    })
                )
            )
        )
    )


    public postPaymentPlanAgreementPdf$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(ActionConfigurationManager.POST_PAYMENY_PLAN_AGREEMENT_PDF),
            switchMap((action: any) => {
                return this.pdfService.postPaymentPlanAgreementPdf(action)
                .pipe(
                    map(pdf => {
                        if (pdf.success) {
                            // Include request metadata to track which request this response belongs to
                            const responsePayload = {
                                ...pdf,
                                pdfRaw: encodeURI(pdf.data),
                                title: "Vehicle Service Contract",
                                frame: "<iframe width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(pdf.data) + "' ></iframe>",
                                data: this.sanitizer.bypassSecurityTrustResourceUrl(`data:application/pdf;base64, ${pdf.data}`),
                                _requestId: action._requestId // Pass through the request ID from the action
                            };
                            return postPaymentPlanAgreementSuccess(responsePayload);
                        } else {
                            return postPaymentPlanAgreementFailed(pdf)
                        }

                    }),
                    catchError((error) => {
                        return throwError(error)
                    })
                )
            })
        )
    )

    //call to the service agreement go get a pdf back
    public postServiceAgreement$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(ActionConfigurationManager.POST_SERVICE_AGREEMENT_PDF),
            switchMap((action: any) => this.pdfService.postServiceAgreementPdf(action)
                .pipe(
                    map(pdf => {
                        if (pdf.success) {
                            return postServiceAgreementSuccess({
                                ...pdf,
                                pdfRaw: encodeURI(pdf.data),
                                title: "Service Agreement",
                                frame: "<iframe width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(pdf.data) + "' ></iframe>",
                                data: this.sanitizer.bypassSecurityTrustResourceUrl(`data:application/pdf;base64, ${pdf.data}`)
                            })
                        } else {
                            return postServiceAgreementFailed(pdf)
                        }

                    }),
                    catchError((error) => {
                        return throwError(error)
                    })
                ))
        )
    )

    public getPaymentPlanAgreement$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(ActionConfigurationManager.GET_PAYMENT_PLAN_AGREEMENT_PDF),
            switchMap((action: any) => this.pdfService.getPaymentPlanAgreementPdf(action)
                .pipe(
                    map(pdf => {
                        if (pdf.success) {
                            let pdfWindow = window.open("")
                            pdfWindow.document.title = 'Payment Plan Agreement.pdf'
                            pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(pdf.data) + "' ></iframe>")
                            return getPaymentPlanAgreementSuccess({
                                ...pdf,
                                title: "Payment Plan Agreement",
                                frame: "<iframe width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(pdf.data) + "' ></iframe>",
                                data: this.sanitizer.bypassSecurityTrustResourceUrl(`data:application/pdf;base64, ${pdf.data}`)
                            })
                        } else {
                            return getPaymentPlanAgreementFailed(pdf)
                        }
                    })
                )
            )
        )
    )

    public downloadPPA$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(ActionConfigurationManager.DOWNLOAD_PAYMENT_PLAN_AGREEMENT_PDF),
            switchMap((action: any) => this.pdfService.getPaymentPlanAgreementPdf(action)
                .pipe(
                    map(pdf => {
                        console.log(pdf);
                        if (pdf) {
                            const linkSource = 'data:application/pdf;base64,' + pdf.data
                            const downloadLink = document.createElement("a");
                            const fileName = "Payment Plan Agreement.pdf";

                            downloadLink.href = linkSource;
                            downloadLink.download = fileName;
                            downloadLink.click();
                            return downloadPaymentPlanAgreementSuccess(pdf);
                        } else {
                            return downloadPaymentPlanAgreementFailed(pdf)
                        }

                    }),
                    catchError((error) => {
                        return throwError(error)
                    })
                )
            )
        )
    )




    public setDateAndTime$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(ActionConfigurationManager.SET_DATE_AND_TIME),
            tap(x => console.log('xxxxxxxxxxxxx', x)),
            switchMap((action: any) => this.pdfService.setDateAndTime(action)
                .pipe(
                    catchError((error) => {
                        return throwError(error)
                    })
                ))
        )
    )

    public getContractByUuid$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(ActionConfigurationManager.GET_CONTRACT_BY_UUID),
            switchMap((action: any) => this.pdfService.getContractByUuid(action)
                .pipe(
                    map(pdf => {
                        console.log('pdf respinse', pdf)
                        if (pdf.status === 'OK') {
                            return getContractByUuidSuccess(pdf)
                        } else {
                            return getContractByUuidFailed(pdf)
                        }
                    }),
                    catchError((error) => {
                        const obj: ViewContractResponse = {
                            status: 'ERROR',
                            data: null,
                            errorMessage: null
                        }
                        this.store.dispatch(getContractByUuidFailed(obj))
                        return throwError(error)
                    })
                ))
        )
    )

    public updatePDFExpiration$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(ActionConfigurationManager.UPDATE_PDF_EXPIRATION),
            switchMap((action: any) => this.pdfService.updatePDFExpiration(action)
                .pipe(
                    map(response => {
                        console.log('update pdf expiration response', response)
                        if (response.status === 'OK') {
                            return updatePDFExpirationSuccess(response)
                        } else {
                            return updatePDFExpirationFailed(response)
                        }
                    }),
                    catchError((error) => {
                        const obj: ViewContractResponse = {
                            status: 'ERROR',
                            data: null,
                            errorMessage: error.error?.errorMessage || error.message || null
                        };
                        this.store.dispatch(updatePDFExpirationFailed(obj));
                        return throwError(error);
                    })
                ))
        )
    )

    public getOhioCancellationForm$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(ActionConfigurationManager.GET_OHIO_CANCELLATION_FORM),
            switchMap((action: any) => this.pdfService.getOhioCancellationForm(action)
                .pipe(
                    map((pdf: any) => {
                        console.log('pdf respinse', pdf)
                        if (pdf.success) {
                            return getOhioCancellationFormSuccess(pdf)
                        } else {
                            return getOhioCancellationFormFailed(pdf)
                        }
                    }),
                    catchError((error) => {
                        const obj: any = {
                            status: false,
                            data: null,
                            errorMessage: null
                        }
                        this.store.dispatch(getOhioCancellationFormFailed(obj))
                        return EMPTY
                    })
                ))
        )
    )


    constructor(
        private actions$: Actions,
        private pdfService: DataLookupService,
        private sanitizer: DomSanitizer,
        private store: Store<{}>
    ) { }
}
